import { differenceInDays, intervalToDuration } from 'date-fns';
import { useRef, useState, useCallback, useEffect } from 'react';

const parts = ['days', 'hours', 'minutes', 'seconds'];

const initialDuration = intervalToDuration({
  start: new Date(),
  end: new Date(),
});

export default function useCountdown(to, pause = false) {
  const interval = useRef();
  const [duration, setDuration] = useState(initialDuration);

  const update = useCallback(() => {
    if (new Date(to) < new Date()) {
      setDuration(initialDuration);
    } else {
      setDuration({
        ...intervalToDuration({
          start: new Date(),
          end: new Date(to),
        }),
        // We want total days not just remainder
        days: differenceInDays(new Date(to), new Date()),
      });
    }
  }, [to]);

  useEffect(() => {
    if (new Date(to) < new Date()) {
      return;
    }
    update();
    // Clear any leftover intervals
    if (interval.current) clearInterval(interval);
    interval.current = window.setInterval(() => {
      update();
    }, 1000);
    return () => window.clearInterval(interval.current);
  }, [to, update]);

  const countdown = {};

  parts.forEach(part => {
    if (pause) {
      countdown[part] = '--';
    } else {
      countdown[part] =
        duration[part] < 10 ? `0${duration[part]}` : duration[part];
    }
  });

  return countdown;
}
